import {styled} from "@mui/material/styles"

export const Cotton22ChevronImage = styled("img", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$isFilterOpen: boolean}>`
    transform: rotate(${({$isFilterOpen}) => ($isFilterOpen ? `180` : `0`)}deg);
    transition: transform 0.2s;
    margin-left: auto;
`

export default Cotton22ChevronImage
